import React, { useState, useEffect, useContext } from "react";
import "./rewardPunchPopup.scss"
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Link } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import Backdrop from "@mui/material/Backdrop";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
// External Components
import Rating from "@mui/material/Rating";
import { styled } from "@mui/material/styles";
import { TextareaAutosize } from "@material-ui/core";
// import {handleCustomerReview} from "../../../../redux-store/action"
import LoaderAnimation from "../LoaderAnimation";
// Context api calling
import StateContext from "../../StateContext";
// Axios
import axios from "axios";
import DispatchContext from "../../DispatchContext";
import { handleError } from "../../Functions/getAlert";
import { handleGoogleReview } from "../../Functions/googleReview";
import { ReactComponent as FireReward } from "../../Assets/images/fireReward.svg";
import { ReactComponent as FireRewardUnfilled } from "../../Assets/images/fireRewardunFilled.svg";
import { handleLoyalPunch, handleMaxPunch } from "../../Functions/handlePunch";
import bigFireImg from "../../Assets/images/bigFire.svg"
import getReward from "../../Assets/images/getReward.svg"




const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledRating = styled(Rating)({
  "& .MuiRating-iconHover": {
    color: "#ff3d47",
  },
});

export default function RewardPunchPopup({ storeInfo, invoiceDetail }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  useEffect(() => {
    setOpen(true)
  }, [])
  

  return (
    <React.Fragment>
    
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >


        <div
          id="mySidenav"
          className={` px-3 rewardModalv2l1   ${appState.langValue == "ar" ? "" : " "
            }`}
        >
          <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">
            &times;
          </a>

          <div
            className={`${appState.langValue === "ar" ? "directionRtl" : ""}`}
            id="rewardModalMainl1"
          >
            {/* <IconButton className="ml-auto my-1 d-flex" onClick={handleClose}>
            <CloseIcon />
          </IconButton> */}
            <div className="px-1">
              <div className="container-fluid mt-5">
                <div className="row d-flex justify-content-center store-tilte-card py-2">
                  <div className="col-md-2 col-6 px-0 d-flex justify-content-center  align-items-center">
                  <div className="imgDiv  d-flex align-items-center w-100 mb-2  px-1">
                        <img
                          src={invoiceDetail?.invoiceable?.loyalty_card_punch == null && invoiceDetail?.invoiceable?.loyalty_card_reward !==null ? getReward :bigFireImg }
                          className="w-100 rounded h-100 img-fluid"
                          alt=""
                        />
                      </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-12 d-flex justify-content-center ">
                    {/* {(true) ? (
                      <div className="punchRatingMain  ">
                    <StyledRating
                          name="customized-color"
                          defaultValue={handleLoyalPunch(
                            3,
                            2,
                            5
                          )}
                          max={handleMaxPunch(
                            5
                          )}
                          getLabelText={(value) =>
                            `${value} Heart${value !== 1 ? "s" : ""
                            }`
                          }
                          precision={0.5}
                          icon={<FireReward/>}
                          emptyIcon={<FireRewardUnfilled/>}
                          disabled
                        />

                      </div>
                    ) : (
                     ""
                    )} */}
                       {/* <StyledRating
                        


                          name="customized-color"
                          defaultValue={handleLoyalPunch(
                            rewards?.punch?.collected,
                            rewards?.punch?.total,
                            5
                          )}
                          max={handleMaxPunch(
                            rewards?.punch?.total
                          )}
                          getLabelText={(value) =>
                            `${value} Heart${value !== 1 ? "s" : ""
                            }`
                          }
                          precision={0.5}
                          icon={
                            <img
                              src={`/images/loyalCardIconFilled.svg`}
                            />
                          }
                          emptyIcon={
                            <img
                              style={{ opacity: 0.55 }}
                              src={`/images/loyalCardIconUnFilled.svg`}
                            />
                          }
                          disabled
                        /> */}
                  </div>

                </div>
              </div>
              <div className="container-fluid mt-3 px-0 mb-4">
                <h1 className="text-center familysora700 pb-2 px-2">
                  {" "}
                  { invoiceDetail?.invoiceable?.loyalty_card_punch == null && invoiceDetail?.invoiceable?.loyalty_card_reward !==null ? 
                  t("Review.You-got-a-reward") 
                   :t("Review.You-got-a-punch")}
                </h1>

               {(invoiceDetail?.invoiceable?.loyalty_card_punch == null && invoiceDetail?.invoiceable?.loyalty_card_reward !==null && invoiceDetail?.invoiceable?.loyalty_card_reward?.amount)&& <p className="text-center familysora700 rewardAmount">{Number(invoiceDetail?.invoiceable?.loyalty_card_reward?.amount)?.toFixed(3)} {t("KWD")}</p>} 
                <h3
                  className={`familysora400 mt-2 ${appState.langValue === "ar" ? "text-center" : "text-center"
                    }`}
                >
                  {t("Review.collect-punches")}
                </h3>


              </div>
            </div>
          </div>
        </div>

      </Dialog>
    </React.Fragment>
  );
}
